import Model, { attr } from '@ember-data/model';

export default class SerpResultCarousel extends Model {
  @attr('string') title;
}
